import React from 'react';
// import { NavLink } from 'react-router-dom';

const services = [
    {
        count: '01',
        title: 'VISION',
        flaticon: 'flaticon-sketch',
        description: 'Our goal is to establish ourselves as one of the most recognized, respected, and reliable construction companies in the country. We aim to achieve this through exceptional service, innovation, and unwavering commitment to quality and sustainability within the next decade.',
    },
    {
        count: '02',
        title: 'MISSION',
        flaticon: 'flaticon-stairs',
        description: 'The company is committed to achieving a track record of excellence in the coming years by building a world-class organization. It aims to set new benchmarks in health, safety, and environmental protection while upholding the highest quality standards in all its activities.',
    },
    {
        count: '03',
        title: 'CORE VALUES',
        flaticon: 'flaticon-window',
        saftyinfo: 'We are committed to achieve total Customer Satisfaction through Quality and On-time project delivery by :',
        description: [
            'A Promise we make is a Promise we keep',
            'Integrity & Honesty',
            'Promptness in action',
            'Humility in behaviour',
            'Commitment to quality and excellence',
            'Building trust through transparency'
        ],
    },
    {
        count: '04',
        title: 'Management Policy on Quality, Safety & Environment',
        flaticon: 'flaticon-brick-wall',
        description: [
            'Continual Improvement in our Process.',
            'Cordial Relationship with all our Stake Holders',
            'Motivating our Employees through training and empowerment.',
            'Complying with all Legal & Statutory requirements',
            'Preventing Pollution & Aiming at Zero accident rate.'
        ],
    }

    // {
    //     count: '04',
    //     title: 'Architecture',
    //     flaticon: 'flaticon-skyline',
    //     description: 'Project management is the process by which our team plans and executes your project. We will develop it...',
    // },
    // {
    //     count: '05',
    //     title: 'Furniture',
    //     flaticon: 'flaticon-bed',
    //     description: 'Our team also provides consultations on all architectural issues, even if you need specific info about working...',
    // },
    // {
    //     count: '06',
    //     title: 'Decoration',
    //     flaticon: 'flaticon-door',
    //     description: 'We combine Interior and Exterior Design services and often provide them as a single solution. It helps us...',
    // }
]

// var bgimg1 = require('./../../images/background/cross-line2.png');

class Services1 extends React.Component {
    render() {

        return (
            <>
                <div className="section-full mobile-page-padding p-b50 bg-gray">
                    <div className="section-content">
                        <div className="container">
                            {/* TITLE START */}
                            {/* <div className="section-head">
                                <div className="sx-separator-outer separator-left">
                                    <div className="sx-separator bg-white bg-moving bg-repeat-x" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                                        <h3 className="sep-line-one ">All Services</h3>
                                    </div>
                                </div>
                            </div> */}
                            {/* TITLE END */}
                            <div className="row">
                                {services.map((item, index) => (
                                    <div className="col-lg-6 col-md-6 col-sm-12 m-b30" key={index}>
                                        <div className="sx-icon-box-wraper  icon-count-2-outer">
                                            <div className="icon-count-2 bg-white">
                                                <span className="icon-count-number">{item.count}</span>
                                                <div className="icon-xl inline-icon m-b5 scale-in-center">
                                                    <span className="icon-cell"><i className={item.flaticon} /></span>
                                                </div>
                                                <div className="icon-content">
                                                    <h4 className="sx-tilte">{item.title}</h4>
                                                    {Array.isArray(item.description) ? (
                                                        <ul>
                                                            {item.description.map((desc, i) => (
                                                                <li key={i}>{desc}</li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <p>{item.description}</p>
                                                    )}
                                                    {/* <div className="text-left">
                                                        <NavLink to={"/services-detail"} className="site-button-link">Read More</NavLink>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                    {/* <div className="hilite-title text-left p-l50 text-uppercase">
                        <strong>Services</strong>
                    </div> */}
                </div>
            </>
        );
    }
};

export default Services1;